import type { RouteRecordRaw } from 'vue-router';
export const mesRoutes: RouteRecordRaw[] = [
  {
    path: 'mes/telemetry',
    name: 'mes-telemetry',
    component: () => import('../pages/mes/MesTelemetryPage.vue'),
    meta: { requiresModule: 'mes' },
  },
];
